export const SEARCH_CONTACTS_DEFAULT = 'Verteilerliste Störungsmeldung VN';

export const Roles = {
  SUPER_ADMIN: 'super_admin',
  SB_CIRCLE_ADMIN: 'admin',
  SB_MASTER_ADMIN: 'master_admin',
};

export const OnSiteDestinationType = {
  OFFICE_PHONE: 1,
  ANSWERING_MACHINE: 2,
  USER: 3,
};

export const OnSiteDestinationId = {
  OFFICE_PHONE: 0,
  ANSWERING_MACHINE: -1,
};

export const DIALOG_EVENTS = {
  CONFIRM: 'confirm',
  CANCEL: 'cancel',
};

export const REDIRECT_USER_ID = 0;
export const SCROLL_DEBOUNCE_MS = 16;

export const SUPPLY_FAILURE_FILTER = {
  ALL: 'all',
  YES: 'yes',
  NO: 'no',
};
